// extracted by mini-css-extract-plugin
var _1 = "ra-overlay-body";
var _2 = "ra-overlay-body-hidden-overflow";
var _3 = "ra-overlay-centered";
var _4 = "ra-overlay-close";
var _5 = "ra-overlay-closing";
var _6 = "ra-overlay";
var _7 = "ra-overlay-container";
var _8 = "ra-overlay-content";
var _9 = "ra-overlay-header-border";
var _a = "ra-overlay-header";
var _b = "ra-overlay-header-content";
var _c = "ra-overlay-header-info";
var _d = "ra-overlay-medium";
var _e = "ra-overlay-semitransparent";
var _f = "ra-overlay-sidebar";
var _10 = "ra-overlay-sidebar-left";
var _11 = "ra-overlay-sidebar-right";
var _12 = "ra-overlay-small";
var _13 = "ra-overlay-visible";
var _14 = "0.3";
export { _1 as "overlayBodyCls", _2 as "overlayBodyHiddenOverflowCls", _3 as "overlayCenteredCls", _4 as "overlayCloseCls", _5 as "overlayClosingCls", _6 as "overlayCls", _7 as "overlayContainerCls", _8 as "overlayContentCls", _9 as "overlayHeaderBorderCls", _a as "overlayHeaderCls", _b as "overlayHeaderContentCls", _c as "overlayHeaderInfoCls", _d as "overlayMediumCls", _e as "overlaySemitransparentCls", _f as "overlaySidebarCls", _10 as "overlaySidebarLeftCls", _11 as "overlaySidebarRightCls", _12 as "overlaySmallCls", _13 as "overlayVisibleCls", _14 as "sidebarAnimationDuration" }
